import { jsx as _jsx } from "react/jsx-runtime";
import { IconButton as MuiIconButton, } from '@mui/material';
import { styled } from '../../utils';
import { Badge } from '../Badge';
import { Icon } from '../Icon';
const IconButtonStyled = styled(MuiIconButton, {
    //intentionally forwarding color so it is passed to Icon
    shouldForwardProp: (prop) => prop !== 'outline',
})(({ theme, color, outline }) => ({
    '&:hover': {
        background: `${theme.palette.primary.main}0A`, //0A sets the alpha value to 0.04
    },
    ...(outline && {
        //80 after the theme color sets alpha value to .5
        border: `${theme.palette.primary.main}80 1px solid`,
        '&:hover': {
            borderColor: theme.palette.primary.main,
        },
    }),
    '&.MuiIconButton-sizeMedium': {
        padding: theme.spacing(1.125),
    },
    '&.MuiIconButton-sizeSmall': {
        padding: theme.spacing(0.5),
    },
    ...(color === 'error' && { color: theme.palette.error.dark }),
    ...(color === 'warning' && {
        backgroundColor: theme.palette.warning.main,
        color: theme.palette.primary.contrastText,
    }),
}));
export function IconButton({ variant, color, size, badgeContent, dataName, ...otherProps }) {
    const sizeProps = size === 'medium' || size === 'small' ? { size } : {}; // TODO: split into to props but no time refactor now
    const icon = _jsx(Icon, { variant: variant, fontSize: size });
    return (_jsx(IconButtonStyled, { color: color, "data-name": dataName, "data-testid": dataName, ...sizeProps, ...otherProps, children: badgeContent ? (_jsx(Badge, { badgeContent: badgeContent, color: "primary", children: icon })) : (icon) }));
}
